import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=fbe3b24c&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"
import style0 from "./TagList.vue?vue&type=style&index=0&id=fbe3b24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe3b24c",
  null
  
)

export default component.exports